// Nebula is a browser/PWA SPA: no SSR, no prerender. Everything runs
// client-side + in Workers (svelte.config.js adapter-static, SPA fallback).
export const ssr = false;
export const prerender = false;
